import sdl from '@jds/react-generated-sdl/JDSHeaderDesktop';
import type { JDSHeaderDesktopProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic, HeaderProps } from '../logic';

const Component = (props: HeaderProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    search = true,
    expandedSearch = true,
    searchActive = false,
    fullWidth = true,
    searchButtonAriaLabel = props.dynamicButtonText?.toString(),
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    {
      search,
      expandedSearch,
      searchActive,
      fullWidth,
      searchButtonAriaLabel,
      ...rest
    },
    'JDSHeaderDesktop',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const Header = withLogic(Component) as React.FC<HeaderProps> & {
  slotName?: string;
};

Header.displayName = 'Header';
Header.slotName = 'jds_header_desktop';

export { Header, type JDSHeaderDesktopProps };
